import React from 'react'
import { Box, Typography } from '@mui/material'

import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'

interface ComparisonBarChartHeaderProps {
  title: string
  mainLabel: string
  currentValue: number
  unitLabel: string
}

const dotsSx = {
  position: 'relative' as const,
  width: '11px',
  height: '4px'
}

const ComparisonBarChartHeader: React.FC<ComparisonBarChartHeaderProps> = ({
  title,
  mainLabel,
  currentValue,
  unitLabel
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        isolation: 'isolate',
        width: '259px',
        alignSelf: 'stretch',
        zIndex: 1
      }}
    >
      <Typography sx={{ ...INTERAX_TYPOGRAPHY.headline5, color: INTERAX_COLORS.white }}>{title}</Typography>

      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '4px', flexWrap: 'wrap' }}>
        <Typography component="span" sx={{ ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.thunderGrey }}>
          {mainLabel}:
        </Typography>
        <Typography component="span" sx={{ ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.white, fontWeight: 600 }}>
          {currentValue}
        </Typography>
        <Typography component="span" sx={{ ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.white }}>
          {unitLabel}
        </Typography>
      </Box>

      <Box sx={dotsSx}>
        <Box
          sx={{
            position: 'absolute',
            width: '4px',
            height: '4px',
            left: 0,
            top: 0,
            background: INTERAX_COLORS.white,
            borderRadius: '50%'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: '2.67px',
            height: '2.67px',
            left: '5.5px',
            top: '0.67px',
            background: INTERAX_COLORS.white70,
            borderRadius: '50%'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: '1.33px',
            height: '1.33px',
            left: '9.66px',
            top: '1.33px',
            background: INTERAX_COLORS.white40,
            borderRadius: '50%'
          }}
        />
      </Box>
    </Box>
  )
}

export default ComparisonBarChartHeader
